import { CustomDatePickerFilter } from '../components/atoms/CustomDatePickerFilter';

export const CUSTOM_DATE_FILTER_OPERATORS_WITHOUT_RELATIVE_TIMES = [
  {
    label: 'is',
    value: 'is',
    InputComponent: CustomDatePickerFilter,
    InputComponentProps: {
      disableRelativeTimes: true,
    },
    getApplyFilterFn: () => null,
  },
  {
    label: 'is not',
    value: 'not',
    InputComponent: CustomDatePickerFilter,
    InputComponentProps: {
      disableRelativeTimes: true,
    },
    getApplyFilterFn: () => null,
  },
  {
    label: 'is after',
    value: 'after',
    InputComponent: CustomDatePickerFilter,
    InputComponentProps: {
      disableRelativeTimes: true,
    },
    getApplyFilterFn: () => null,
  },
  {
    label: 'is on or after',
    value: 'onOrAfter',
    InputComponent: CustomDatePickerFilter,
    InputComponentProps: {
      disableRelativeTimes: true,
    },
    getApplyFilterFn: () => null,
  },
  {
    label: 'is before',
    value: 'before',
    InputComponent: CustomDatePickerFilter,
    InputComponentProps: {
      disableRelativeTimes: true,
    },
    getApplyFilterFn: () => null,
  },
  {
    label: 'is on or before',
    value: 'onOrBefore',
    InputComponent: CustomDatePickerFilter,
    InputComponentProps: {
      disableRelativeTimes: true,
    },
    getApplyFilterFn: () => null,
  },
  {
    label: 'is empty',
    value: 'isEmpty',
    getApplyFilterFn: () => null,
  },
  {
    label: 'is not empty',
    value: 'isNotEmpty',
    getApplyFilterFn: () => null,
  },
];

export const CUSTOM_DATE_FILTER_OPERATORS = [
  {
    label: 'is',
    value: 'is',
    InputComponent: CustomDatePickerFilter,
    InputComponentProps: {
      tooltipTopMargin: 252,
    },
    getApplyFilterFn: () => null,
  },
  {
    label: 'is not',
    value: 'not',
    InputComponent: CustomDatePickerFilter,
    InputComponentProps: {
      tooltipTopMargin: 252,
    },
    getApplyFilterFn: () => null,
  },
  {
    label: 'is after',
    value: 'after',
    InputComponent: CustomDatePickerFilter,
    InputComponentProps: {
      tooltipTopMargin: 252,
    },
    getApplyFilterFn: () => null,
  },
  {
    label: 'is on or after',
    value: 'onOrAfter',
    InputComponent: CustomDatePickerFilter,
    InputComponentProps: {
      tooltipTopMargin: 252,
    },
    getApplyFilterFn: () => null,
  },
  {
    label: 'is before',
    value: 'before',
    InputComponent: CustomDatePickerFilter,
    InputComponentProps: {
      tooltipTopMargin: 252,
    },
    getApplyFilterFn: () => null,
  },
  {
    label: 'is on or before',
    value: 'onOrBefore',
    InputComponent: CustomDatePickerFilter,
    InputComponentProps: {
      tooltipTopMargin: 252,
    },
    getApplyFilterFn: () => null,
  },
  {
    label: 'is empty',
    value: 'isEmpty',
    getApplyFilterFn: () => null,
  },
  {
    label: 'is not empty',
    value: 'isNotEmpty',
    getApplyFilterFn: () => null,
  },
];
